import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'beIN SPORTS',
    callsign: 'beIN1HD',
    logoUrl: networkLogos.bein.logoUrl,
    slug: 'bein-sports',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="beIN1HD"
        title="Watch beIN SPORTS live with Fubo"
        networkName="beIN SPORTS"
      />
    </>
  )
}
